// extracted by mini-css-extract-plugin
module.exports = {"item":"style_item__1XSAB","icon":"style_icon__tjp74","setIcon":"style_setIcon__3ssow","setIconActive":"style_setIconActive__2bBK0","link":"style_link__SoZ2D"};